<template>
  <div>
    <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onReset">
      <SpFilterFormItem prop="order_id">
        <el-input v-model="formData.order_id" placeholder="请输入订单号" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="item_id">
        <el-button class="btn_input" size="medium" @click="handleClick('online')">
          {{ onLineText }}
          <i :class="getIconClass(onlineSubsidyItems)" @click.stop="handleClear('online')"></i>
        </el-button>
      </SpFilterFormItem>
      <SpFilterFormItem prop="distributor_id">
        <el-button class="btn_input" size="medium" @click="handleClick('shop')">
          {{ shopText }}
          <i :class="getIconClass(distributorIds)" @click.stop="handleClear('shop')"></i>
        </el-button>
      </SpFilterFormItem>
      <SpFilterFormItem prop="subsidy_goods_type">
        <el-select v-model="formData.subsidy_goods_type" clearable placeholder="商品类型">
          <el-option label="3C" size="mini" value="3c"></el-option>
          <el-option label="家电" size="mini" value="appliances"></el-option>
        </el-select>
      </SpFilterFormItem>
    </SpFilterForm>
    <SpFinder
      ref="finder"
      row-key="id"
      :split-count="10"
      :url="table_url"
      :setting="setting"
      fixed-row-action
      reserve-selection
      no-selection
      :hooks="{
        beforeSearch: beforeSearch,
      }"
    >
      <template slot="tableTop">
        <el-button type="primary" @click="exportData" v-loading="exportloading" style="margin-bottom: 20px">导出</el-button>
      </template>
    </SpFinder>
    <GoodsSelect
      :items-visible="onlineVisible"
      :is-spu=true
      :item-tier="itemNormal"
      :get-status="onlineItemStatus"
      :rel-items-ids="onlineSubsidyItems"
      :support_gov_subsidy="1"
      @chooseStore="chooseItemsAction"
      @closeStoreDialog="handleItemClose"
    ></GoodsSelect>
    <DistributorSelect
      :store-visible="distributorVisible"
      :is-valid="true"
      :rel-data-ids="distributorIds"
      :get-status="distributorStatus"
      @chooseStore="chooseShopAction"
      @closeStoreDialog="handleShopClose"
    />
  </div>
</template>
<script>
import DistributorSelect from '@/components/function/distributorSelect'
import GoodsSelect from '@/components/goodsSelect'
import ImportDialog from '@/components/importDialog'
import { useDialog } from '@shopex/finder'
import { tableSetting } from './config'
import { List, handleExport } from './api'

export default {
  components: {
    ImportDialog,
    DistributorSelect,
    GoodsSelect
  },
  data () {
    return {
      table_url: List,
      formData: {
        order_id: '',
        subsidy_goods_type: '',
        distributor_id: [],
        item_id: []
        // goods_type: '',
        // distributor: ''
      },
      itemNormal: [
        'normal',
      ],
      exportloading: false,
      distributorVisible: false,
      distributorStatus: false,
      distributorIds: [],
      onlineVisible: false,
      onlineItemStatus: false,
      onlineSubsidyItems: [],
    }
  },
  computed: {
    shopText() {
      return this.getSelectedText(this.distributorIds, 'shop')
    },
    onLineText () {
      return this.getSelectItemText(this.onlineSubsidyItems, 'online')
    },
    setting() {
      return tableSetting(this)
    }
  },
  mounted() {
  },
  methods: {
    handleItemClose() {
      this.onlineVisible = false
      this.onlineItemStatus = false
    },
    handleShopClose() {
      this.distributorVisible = false
      this.distributorStatus = false
    },
    handleClear(type) {
      if (type == 'shop') {
        this.distributorVisible = false
        this.distributorStatus = false
        this.distributorIds = []
        this.formData.distributor_id = []
      } else {
        this.onlineVisible = false
        this.onlineItemStatus = false
        this.onlineSubsidyItems = []
        this.formData.item_id = []
      }
    },
    getSelectedText(items) {
      return items.length > 0 ? `已选择${items.length}家门店` : '国补门店'
    },
    getSelectItemText(items, type) {
      return items.length > 0 ? `已选择${items.length}个商品` : '国补商品'
    },
    getIconClass(items) {
      return items.length === 0 ? 'el-icon-circle-plus icon' : 'el-icon-circle-close icon'
    },
    chooseShopAction (data) {
      if (data === null || data.length <= 0) return this.$message.error('请选择店铺')
      const ids = data.map(item => item.distributor_id)
      this.distributorIds = data
      this.formData.distributor_id = ids
      this.handleShopClose()
    },
    chooseItemsAction (data) {
      if (data === null || data.length <= 0) return this.$message.error('请选择商品')
      const ids = data.map(item => item.item_id)
      this.onlineSubsidyItems = data
      this.formData.item_id = ids
      this.handleItemClose()
    },
    async handleClick(type) {
      this.selectType = type
      if (type == 'shop') {
        this.distributorVisible = true
        this.distributorStatus = true
      } else {
        this.onlineVisible = true
        this.onlineItemStatus = true
      }
    },
    beforeSearch(params) {
      params = {
        ...params,
        page_size: params.pageSize,
        ...this.formData
      }
      return params
    },
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    onReset () {
      this.formData = {
        item_id: [],
        distributor_id: [],
      }
      this.distributorIds = []
      this.onlineSubsidyItems = []
      this.$refs.finder.refresh(true)
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    exportData() {
      if (this.exportloading) return
      this.exportloading = true
      let params = {
        ...this.formData,
        is_export: 1
      };
      handleExport(params).then((res) => {
        if (res.data.data.success == true) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表中下载'
          });
        } else {
          this.$message({
            type: 'error',
            message: '导出失败'
          });
        }
        this.exportloading = false
      })
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep .sp-finder .cell .sp-finder-actions__wrap {
  justify-content: center !important;
}
</style>
